<!-- Desktop: single row | Mobile: icon+close top, text middle, button bottom-left -->
<div *ngIf="visible && !dismissed"
     class="flex flex-col sm:flex-row sm:items-center w-full py-3 px-6 bg-blue-50 border-b border-blue-100 text-sm text-gray-700">
    <!-- Mobile: icon + close on same row -->
    <div class="flex items-center justify-between sm:hidden mb-2">
        <mat-icon class="icon-size-5 text-gray-500" [svgIcon]="'heroicons_outline:information-circle'"></mat-icon>
        <button class="text-gray-400 hover:text-gray-600 transition-colors duration-200 bg-transparent border-none p-0 cursor-pointer"
                (click)="dismiss()">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>
    <!-- Desktop: icon inline -->
    <mat-icon class="hidden sm:block icon-size-5 text-gray-500 mr-3 flex-shrink-0" [svgIcon]="'heroicons_outline:information-circle'"></mat-icon>
    <!-- Text -->
    <p class="flex-1 min-w-0 m-0 leading-5">
        <ng-container *ngIf="atLimit">
            <span>{{ 'features.upsell.top_bar.message_reached' | transloco:{ limit: dishLimit } }}</span>
        </ng-container>
        <ng-container *ngIf="!atLimit">
            <span>{{ 'features.upsell.top_bar.message' | transloco:{ count: excessCount, limit: dishLimit } }}</span>
        </ng-container>
    </p>
    <!-- Button -->
    <button class="mt-2 sm:mt-0 sm:ml-4 flex-shrink-0 text-xs h-8 leading-none whitespace-nowrap px-4 rounded-md bg-primary text-white font-medium hover:opacity-90 transition-opacity duration-200 cursor-pointer border-none self-start sm:self-auto"
            (click)="openUpgradeDialog()">
        {{ 'features.upsell.top_bar.upgrade_button' | transloco }}
    </button>
    <!-- Desktop: close button -->
    <button class="hidden sm:block ml-4 flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors duration-200 bg-transparent border-none p-0 cursor-pointer"
            (click)="dismiss()">
        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>
</div>
